import React from 'react';
import Options from 'Components/Options';
import { Grid, MenuItem, ListItemAvatar, Avatar } from '@mui/material';
import useLogOut from 'Hooks/useLogOut';
import useTranslation from 'Hooks/useTranslation';
import ui from './index.module.css';

export default function index({ title = '' }) {
  const { t2 } = useTranslation('Dashboard');
  const { logOutApi } = useLogOut();
  return (
    <div className={ui.container}>
      <h1 className={ui.navTitle}>{title}</h1>
      <div className={ui.navIcon}>
        <Options
          Icon={
            <Grid container display="flex" alignItems="center" spacing={0}>
              <Grid item xs={7}>
                <ListItemAvatar>
                  <Avatar alt="" src="" />
                </ListItemAvatar>
              </Grid>
            </Grid>
          }
          disabledEffect
        >
          <MenuItem onClick={logOutApi}>{t2('Logout')}</MenuItem>
        </Options>
      </div>
    </div>
  );
}
